import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import useAutosizeTextArea from '../../hooks/useAutosizeTextarea';
import VoiceMessageButton from '../voiceMessageButton/voiceMessageButton';
import { useVoiceRecorder } from '../../hooks/useVoiceRecorder'; // 1. ייבוא

interface ReplyBarStyles {
  replyBar: string;
  replyBarAudio: string;
  message: string;
  textArea: string;
  btn: string;
  sendBtn: string;
}

interface ReplyBarProps {
  isLoading: boolean;
  isFinished: boolean;
  onSendMessage: (text: string) => void;
  onSendVoiceMessage: (audioBlob: Blob) => void;
  styles: ReplyBarStyles; 
}

const ReplyBar = forwardRef<HTMLTextAreaElement, ReplyBarProps>(({
  isLoading,
  isFinished,
  onSendMessage,
  onSendVoiceMessage,
  styles,
}, ref) => {
  const [textValue, setTextValue] = useState('');
  const localTextAreaRef = useRef<HTMLTextAreaElement>(null); 
  useAutosizeTextArea(localTextAreaRef.current, textValue);
  useImperativeHandle(ref, () => localTextAreaRef.current as HTMLTextAreaElement);

  const { isRecording, audioURL, startRecording, stopRecording, deleteRecord } = useVoiceRecorder();

  const handleTextSend = () => {
    if (textValue.trim()) {
      onSendMessage(textValue.trim());
      setTextValue(''); 
    }
  };

  const isVoiceActive = isRecording || !!audioURL;

  return (
    <div className={`${styles.replyBar} ${isVoiceActive ? styles.replyBarAudio : ''}`}>
      {isVoiceActive ? (
        <VoiceMessageButton
          isRecording={isRecording}
          audioURL={audioURL}
          onStop={stopRecording}
          onDelete={deleteRecord}
          onSend={async () => {
              if (audioURL) {
                  const response = await fetch(audioURL);
                  const blob = await response.blob();
                  onSendVoiceMessage(blob);
                  deleteRecord();
              }
          }}
          disabled={isLoading}
        />
      ) : (
        <>
          <textarea
            name={"reply"}
            data-testid="chat-text-input"
            className={`${styles.message} ${styles.textArea}`}
            ref={localTextAreaRef}
            rows={1}
            // autoFocus
            placeholder={isFinished ? t('THE_CONVERSATION_ENDED') : t('WRITE_MESSAGE')}
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            disabled={isFinished || isLoading}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleTextSend(); }
            }}
          />
          {textValue ? (
            <button
              className={`${styles.btn} ${styles.sendBtn}`}
              onClick={handleTextSend}
              disabled={!textValue || isFinished || isLoading}
            />
          ) : (
            <VoiceMessageButton
              isRecording={isRecording}
              audioURL={audioURL}
              onStart={startRecording}
              onStop={stopRecording}
              onDelete={deleteRecord}
              onSend={() => {}}
              disabled={isFinished || isLoading}
            />
          )}
        </>
      )}
    </div>
  );
});
  
export default ReplyBar;